import delay from "../common/mock/delay";
import * as mockData from "./mockData";



class DashboardApi {
    static getSecurityAlertsForLastMonth() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve(mockData.securityAlertsLastMonth);
            }, delay);
        });
    }

     static getSecurityAlertsLastWeek() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve(mockData.securityAlertsLastWeek);
            }, delay);
        });
    }

     static getSystemStatus() {
         return fetch(`${global.applicationPath}api/systemstatus`)
             .then(response => response.json());
     }

    static getIncidents() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve(Object.assign({}, []));
            }, delay);
        });
    }
    
    static getLogSources() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve([...mockData.logsSources]);
            }, delay);
        });
    }

    static getLogsPerDay() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve(mockData.logsPerDay);
            }, delay);
        });
    }

    static getDeviceGroups() {
        return new Promise((resolve, reject) => {
            return setTimeout(() => {
                resolve(mockData.deviceGroups);
            }, delay);
        });
    }
}

export default DashboardApi;


// WEBPACK FOOTER //
// ./src/dashboard/mockDashboardApi.js